/* global jQuery */
(function ($) {
	"use strict";

	// when header is below banner, change its colors
	$(document).ready(function () {
		// cut local nav HTML
		var $localNav = $("div.local-nav").detach("div.local-nav");
		// paste it into header
		$("#header").append($localNav);

		var $headerWrapper = $("div.header-wrapper");
		var $mainNav = $("#nav");
		var $mobileHeader = $("div.mobile-header");
		var $toolbar = $("#header div.toolbar");
		var $globalLink = $("#header a.global-link");

		function showLocalNav() {
			$headerWrapper.removeClass("transparent");
			$mobileHeader.removeClass("transparent");
			$mainNav.addClass("hidden");
			$toolbar.addClass("hidden");
			$localNav.removeClass("hidden");
			$globalLink.removeClass("hidden");
		}

		function showGlobalNav() {
			$headerWrapper.addClass("transparent");
			$mobileHeader.addClass("transparent");
			$mainNav.removeClass("hidden");
			$toolbar.removeClass("hidden");
			$localNav.addClass("hidden");
			$globalLink.addClass("hidden");
		}

		if (document.body.scrollTop > $("div.banner h2").offset().top-200) {
			setTimeout(showLocalNav, 0);
		} else {
			setTimeout(showGlobalNav, 0);
		}

		var descroll = function () {
			if (document.body.scrollTop > $("div.banner h2").offset().top-200) {
				setTimeout(showLocalNav, 0);
			} else {
				setTimeout(showGlobalNav, 0);
			}
		};

		$(window).on("scroll", descroll);
	});
}(jQuery));
